import { Box } from '@chakra-ui/react';
import { useUser } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { DevUtilitiesButton } from '~/components/dev-utilities/DevUtilitiesButton';
import { Provider } from '~/components/ui/provider';
import { useHydrateProjectStore } from '~/hooks/useProjectStore';
import Routings from '~/router/Routings';
import { AppConfig } from '~/services/app-config-service';

const queryClient = new QueryClient();

const App = () => {
  const { user, isSignedIn } = useUser();
  const posthog = usePostHog();

  // Identify user to PostHog when signed in (production only)
  useEffect(() => {
    if (!AppConfig.isProduction) return;

    if (isSignedIn && user && posthog) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName,
        firstName: user.firstName,
        lastName: user.lastName,
      });
    } else if (!isSignedIn && posthog) {
      posthog.reset();
    }
  }, [isSignedIn, user, posthog]);

  // Wait for project store to be ready before rendering
  const hasHydrated = useHydrateProjectStore();

  // Wait for store to hydrate before rendering routes
  if (!hasHydrated) {
    return null; // Or a loading spinner if preferred
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Provider>
        <Box className="id--app">
          <Router>
            <Routings />
            <DevUtilitiesButton />
          </Router>
        </Box>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
